import React from 'react';

import Paginator from '../../../../../components/Paginator/index';
import { INavigationTip } from '../../../../types/navigationTips';

import CustomHeader from './CustomHeader';
import CustomTable from './CustomTable';

interface ShowProps {
    navigationTips: INavigationTip[];
    page: number;
    totalPages: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onLoadMore: () => void;
    sortBy: string;
    sortDir: 'asc' | 'desc';
    onSort: (key: string) => void;
    searchValue: string;
    onSearchChange: (v: string) => void;
    onOpenFilter: () => void;
    onStatusChange: (v: string) => void;
    dataCards: { title: string; value: number }[];
    filterType: string;
    filterStatus: string;
    modalType: string;
    modalStatus: string;
    setModalType: (v: string) => void;
    setModalStatus: (v: string) => void;
    setOpenFilter: (v: boolean) => void;
    setFilterStatus: (v: string) => void;
    setFilterType: (v: string) => void;
    onCreateEdit: () => void;
    onEditTip: (tip: INavigationTip) => void;
    onDeleteTip: (tipId: string) => void;
    onRefresh?: () => void;
}

const Show: React.FC<ShowProps> = (props) => {
    return (
        <div className="padding-50">
            <CustomHeader dataCards={props.dataCards} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <CustomTable
                            data={props.navigationTips}
                            page={props.page}
                            totalPages={props.totalPages}
                            onPageChange={props.onPageChange}
                            onLoadMore={props.onLoadMore}
                            sortBy={props.sortBy}
                            sortDir={props.sortDir}
                            onSort={props.onSort}
                            searchValue={props.searchValue}
                            onSearchChange={props.onSearchChange}
                            onEditTip={props.onEditTip}
                            onDeleteTip={props.onDeleteTip}
                            onCreateEdit={props.onCreateEdit}
                        />
                        <Paginator
                            handlePage={params => props.onPageChange(params.page)}
                            page={props.page}
                            pages={props.totalPages}
                            pageSize={props.pageSize}
                            disabled={props.navigationTips.length == 0}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Show; 